// src/components/popups/CreatorGraphsExplainerDrawer.js
import React from 'react';
import './GraphsExplainerDrawer.css';

const COPY = {
  avgPostsPerDay: {
    title: 'Avg Posts / Day',
    body: [
      'Average number of posts you created per day in this period.',
      'Shows your posting consistency over time.',
    ],
  },



avgLikesPerPost: {
  title: 'Likes / Post',
  body: [
    'Likes received on each post in this period.',
    'Use it to compare your posts (Post #1, Post #2, etc).',
  ],
},
avgCommentsPerPost: {
  title: 'Comments / Post',
  body: [
    'Comments received on each post in this period.',
    'Shows which posts started more conversations.',
  ],
},
engagementDensity: {
  title: 'Engagement / Post',
  body: [
    'Total engagement on each post in this period.',
    'Engagement = likes + comments + shares + saves.',
  ],
},


};


export default function CreatorGraphsExplainerDrawer({ open, onClose, type = 'avgPostsPerDay' }) {
  if (!open) return null;

  const content = COPY[type] || COPY.avgPostsPerDay;

  return (
    <div className="ged-backdrop" onClick={onClose}>
      <div className="ged-sheet" onClick={(e) => e.stopPropagation()}>
        <div className="ged-handle" />
        <div className="ged-header">
          <div className="ged-title">{content.title}</div>
          <button className="ged-close" onClick={onClose} aria-label="Close">
            ✕
          </button>
        </div>

        <div className="ged-body">
          {content.body.map((t, idx) => (
            <div key={idx} className="ged-line">• {t}</div>
          ))}
        </div>

        <div className="ged-footer">
          <button className="ged-btn" onClick={onClose}>Got it</button>
        </div>
      </div>
    </div>
  );
}
